import { FC } from 'react';

const IconTransfersExtraLarge: FC = () => (
  <svg
    width="26"
    height="24"
    viewBox="0 0 26 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.40654 10.477H23.5936C24.8495 10.477 25.565 9.04296 24.8099 8.03971L18.7615 0L16.3272 1.83143L20.5427 7.43228H6.33125C5.41477 7.43228 4.54853 7.84636 3.97003 8.55732L2.40654 10.477ZM7.23987 23.9997L1.18991 15.96C0.434812 14.9567 1.15185 13.5211 2.4063 13.5211H23.7197L22.1577 15.4424C21.5792 16.1533 20.7114 16.5659 19.795 16.5659H5.45716L9.67264 22.1682L7.23987 23.9997Z"
      fill="currentColor"
    />
  </svg>
);

export { IconTransfersExtraLarge };
